import React, {useRef} from 'react';
import { classNames, getContrastColor, strToHsl } from '../../Services/helpers';
import { useGrants } from '../../Data/Business';
import Icon from '../Icons/Icon';
import Tooltip from '../Tooltip';

const sizes = {
    '2': 'w-2 h-2',
    '4': 'w-4 h-4',
    '5': 'w-5 h-5',
    '6': 'w-6 h-6',
    '8': 'w-8 h-8',
    '10': 'w-10 h-10',
}

const Grant = ({grantId, size = "4"}) => {
    const {grants} = useGrants();
    const grant = grants ? grants.find(g => g.id === grantId) : null;
    const ref = useRef(null);

    const classes = `relative ${sizes[size] ?? 'w-4 h-4'} rounded-full font-bold flex items-center justify-center`;

    if (!grant)  {
        return <div className={classNames(classes, 'bg-gray-300 fill-white')} ref={ref}>
            <Icon icon="Question" size="1.5x" />
            <Tooltip watch={ref} content="Unassigned" below />
        </div>;
    }

    const color = strToHsl(grantId);

    return <div className={classes}
        style={{backgroundColor: color, color: getContrastColor(color)}}
        ref={ref}
    >
        {grant.initials}
        <Tooltip watch={ref} content={grant.title} below />
    </div>
}


export default Grant;